import { __ } from "services/Translator";

const gameTypeAPISlugs = {
  all: "all",
  slots: "video_slots",
  blackjack: "blackjack",
  "live-dealer": "live_casino",
  "live-casino": "live_casino",
  "bonus-buy": "bonus_buy",
  megaways: "megaways",
  jackpot: "jackpot",
  "table-games": "table_games",
  popular: "popular",
  top: "popular",
  new: "new",
  search: "search_results",
  "provably-fair": "provably-fair",
  skills: "skills",
  crash: "crash",
  original: "original",
  roulette: "roulette",
  baccarat: "baccarat",
  poker: "poker",
  others: "other",
  crash_games: "crash_games",
  "game-shows": "game_shows",
  "drops-wins": "drops_wins",
};

const gameTitles = {
  all: __("All Games"),
  slots: __("Slots"),
  video_slots: __("Slots"),
  blackjack: __("Blackjack"),
  "live-dealer": __("Live Dealer"),
  "live-casino": __("Live Casino"),
  "bonus-buy": __("Bonus Buy"),
  megaways: __("Megaways"),
  jackpot: __("Jackpot"),
  "table-games": __("Table Games"),
  table_games: __("Video Table Games"),
  popular: __("Popular"),
  popular: __("Top"),
  new: __("New"),
  search_results: __("Search Results"),
  "provably-fair": __("Provably Fair"),
  skills: __("Skills"),
  crash: __("Crash"),
  original: __("Original"),
  roulette: __("Roulette"),
  baccarat: __("Baccarat"),
  poker: __("Poker"),
  other: __("Others"),
  crash_games: __("Crash Games"),
  game_shows: __("Game Shows"),
  "drops-wins": __("Drops & Wins"),
  drops_wins: __("Drops & Wins"),
};

const gameTypeIcons = {
  all: (
    <svg fill="currentColor" viewBox="0 0 96 96" class="svg-icon ">
      {" "}
      <title></title>{" "}
      <path d="M30.48 42.441a79.7 79.7 0 0 0-5.8 15.84 30.1 30.1 0 0 0 0 14.36l.718 3-16.277 4A37.9 37.9 0 0 1 12 53.719l-12 2.84v-11.68l29.36-7.04zM96 46.88l-.922 4.64A85.5 85.5 0 0 0 83.2 63.32a30.56 30.56 0 0 0-6 13.04l-.597 3L60 76.32a38.12 38.12 0 0 1 13.36-22.28l-12-2.36 5.038-10.64zM72 24.12a134 134 0 0 0-15.2 22.957 49.8 49.8 0 0 0-5.6 22.8v5H32.32a55.6 55.6 0 0 1 5-22.757A87 87 0 0 1 50.8 31h-28V16.36H72z"></path>
    </svg>
  ),
  slots: (
    <svg fill="currentColor" viewBox="0 0 96 96" class="svg-icon ">
      {" "}
      <title></title>{" "}
      <path d="M30.48 42.441a79.7 79.7 0 0 0-5.8 15.84 30.1 30.1 0 0 0 0 14.36l.718 3-16.277 4A37.9 37.9 0 0 1 12 53.719l-12 2.84v-11.68l29.36-7.04zM96 46.88l-.922 4.64A85.5 85.5 0 0 0 83.2 63.32a30.56 30.56 0 0 0-6 13.04l-.597 3L60 76.32a38.12 38.12 0 0 1 13.36-22.28l-12-2.36 5.038-10.64zM72 24.12a134 134 0 0 0-15.2 22.957 49.8 49.8 0 0 0-5.6 22.8v5H32.32a55.6 55.6 0 0 1 5-22.757A87 87 0 0 1 50.8 31h-28V16.36H72z"></path>
    </svg>
  ),
  video_slots: (
    <svg fill="currentColor" viewBox="0 0 96 96" class="svg-icon ">
      {" "}
      <title></title>{" "}
      <path d="M30.48 42.441a79.7 79.7 0 0 0-5.8 15.84 30.1 30.1 0 0 0 0 14.36l.718 3-16.277 4A37.9 37.9 0 0 1 12 53.719l-12 2.84v-11.68l29.36-7.04zM96 46.88l-.922 4.64A85.5 85.5 0 0 0 83.2 63.32a30.56 30.56 0 0 0-6 13.04l-.597 3L60 76.32a38.12 38.12 0 0 1 13.36-22.28l-12-2.36 5.038-10.64zM72 24.12a134 134 0 0 0-15.2 22.957 49.8 49.8 0 0 0-5.6 22.8v5H32.32a55.6 55.6 0 0 1 5-22.757A87 87 0 0 1 50.8 31h-28V16.36H72z"></path>
    </svg>
  ),
  blackjack: (
    <svg fill="currentColor" viewBox="0 0 96 96" class="svg-icon ">
      {" "}
      <title></title>{" "}
      <path d="M88.736 40.644 51.972 3.564a5.3 5.3 0 0 0-3.797-1.595 5.3 5.3 0 0 0-3.794 1.594L7.22 40.605A25.28 25.28 0 0 0 0 58.332c0 13.375 10.351 24.335 23.478 25.303l.084.005h1.837a25.5 25.5 0 0 0 10.944-2.463l-.155.066a37.3 37.3 0 0 1-8.787 7.46l-.162.092a2.84 2.84 0 0 0-1.322 2.398 2.84 2.84 0 0 0 2.796 2.838h38.523a2.838 2.838 0 0 0 1.49-5.23l-.013-.006c-3.371-2.089-6.254-4.567-8.709-7.423l-.042-.048c3.162 1.51 6.872 2.392 10.786 2.397h1.84C85.733 82.672 96 71.746 96 58.425a25.3 25.3 0 0 0-7.273-17.781l.002.003zM46.62 57.187l-2.637 11.23H17.01l2.316-10.91.758-.398c10.109-5.074 15.905-8.352 15.905-9.83a5.36 5.36 0 0 0-2.332-.399h.012a9.9 9.9 0 0 0-5.898 2.017l.024-.018-1.678 1.2-5.074-9.39 1.2-.96c3.296-2.496 7.467-3.997 11.99-3.997q.126 0 .251.003h-.011c8.39 0 14.265 4.516 14.265 10.99a12.44 12.44 0 0 1-6.566 10.516l-.066.033zm21.976 11.23H56.168l3.237-14.746-3.318 2.719-5.955-7.993L65.318 36.05h10.39z"></path>
    </svg>
  ),
  "live-dealer": (
    <svg fill="currentColor" viewBox="0 0 96 96" class="svg-icon ">
      {" "}
      <title></title>{" "}
      <path d="M62.8 7.198h-1.2l-13.599 4.8-13.599-4.8c-2.4-.8-5.199.801-5.6 3.6v10c0 2.798 2.4 4.8 4.8 4.8h1.2l13.2-6 13.598 6c2.8.8 5.2-.802 6-3.6v-10c0-2.799-2.4-4.8-4.8-4.8m-21.6 75.6-18-60c-1.2-2.4-3.6-3.6-6.399-2.799l-6 2.001C8.8 22.4 7.6 24.4 7.6 26.401L4 84.001c0 2.8 2.001 4.8 4.401 5.2H36.4c2.799 0 4.8-2.002 4.8-4.8.399-.4 0-1.204 0-1.603m47.202-56.399c0-2.001-1.2-3.6-3.2-4.402l-6-2.4c-2.4-.8-5.2.4-6 2.8l-18 60c-.802 2.4.8 5.198 3.2 6 .4 0 .801.398 1.6.398h27.6c2.798 0 4.8-2 4.8-4.8z"></path>
    </svg>
  ),
  "live-casino": (
    <svg fill="currentColor" viewBox="0 0 96 96" class="svg-icon ">
      {" "}
      <title></title>{" "}
      <path d="M62.8 7.198h-1.2l-13.599 4.8-13.599-4.8c-2.4-.8-5.199.801-5.6 3.6v10c0 2.798 2.4 4.8 4.8 4.8h1.2l13.2-6 13.598 6c2.8.8 5.2-.802 6-3.6v-10c0-2.799-2.4-4.8-4.8-4.8m-21.6 75.6-18-60c-1.2-2.4-3.6-3.6-6.399-2.799l-6 2.001C8.8 22.4 7.6 24.4 7.6 26.401L4 84.001c0 2.8 2.001 4.8 4.401 5.2H36.4c2.799 0 4.8-2.002 4.8-4.8.399-.4 0-1.204 0-1.603m47.202-56.399c0-2.001-1.2-3.6-3.2-4.402l-6-2.4c-2.4-.8-5.2.4-6 2.8l-18 60c-.802 2.4.8 5.198 3.2 6 .4 0 .801.398 1.6.398h27.6c2.798 0 4.8-2 4.8-4.8z"></path>
    </svg>
  ),
  "bonus-buy": (
    <svg fill="currentColor" viewBox="0 0 96 96" class="svg-icon ">
      {" "}
      <title></title>{" "}
      <path d="M47.969.004c11.318 0 21.72 3.92 29.828 10.402l.097.074C88.928 19.269 96 32.82 96 48.024c0 26.389-21.304 47.8-47.668 47.973h-.016c-9.516-.18-17.175-7.946-17.175-17.504 0-1.916.306-3.762.84-5.363l.163-.582c.95-2.944 2.065-5.82 3.118-8.09l.914.598a15.2 15.2 0 0 0 7.89 2.195c.375 0 .75-.011 1.067-.035-2.317 7.555 2.601 17.39 2.601 17.39 14.459-14.458 10.96-25.327 10.914-25.464C76.763 41.025 73.228 22.906 73.2 22.76c0 0-18.188-3.639-36.379 14.552 0 0-10.914-3.64-25.464 10.953.115.057 9.88 4.901 17.39 2.597l-.035 1a15.4 15.4 0 0 0 2.793 8.875l.492-.203c-2.785 1.268-5.663 2.383-9.168 3.48l-1.172.329a17.6 17.6 0 0 1-4.105.484C7.95 64.828.15 57.123 0 47.547v-.363C.424 21.054 21.74.004 47.969.004m14.32 40.945a5.16 5.16 0 0 1-7.562-6.926L55 33.68a5.162 5.162 0 0 1 8.559 3.883 5.13 5.13 0 0 1-1.27 3.386"></path>
    </svg>
  ),
  megaways: (
    <svg fill="currentColor" viewBox="0 0 64 64" class="svg-icon ">
      {" "}
      <title></title>{" "}
      <path d="M29.813 0 0 29.84v11.413h22.773v22.745h11.334L64 34.213V0zm22.745 29.333-18.4 18.346V29.865H16.135l18.533-18.4h18.025z"></path>
    </svg>
  ),
  "drops-wins": (
    <svg fill="currentColor" viewBox="0 0 64 64" class="svg-icon ">
      {" "}
      <title></title>{" "}
      <path d="M29.813 0 0 29.84v11.413h22.773v22.745h11.334L64 34.213V0zm22.745 29.333-18.4 18.346V29.865H16.135l18.533-18.4h18.025z"></path>
    </svg>
  ),
  jackpot: (
    <svg fill="currentColor" viewBox="0 0 64 64" class="svg-icon ">
      {" "}
      <title></title>{" "}
      <path d="M29.813 0 0 29.84v11.413h22.773v22.745h11.334L64 34.213V0zm22.745 29.333-18.4 18.346V29.865H16.135l18.533-18.4h18.025z"></path>
    </svg>
  ),
  "table-games": (
    <svg fill="currentColor" viewBox="0 0 96 96" class="svg-icon ">
      {" "}
      <title></title>{" "}
      <path d="M60 0c-8.001 0-24 15.999-24 36 0 0-3.999-12-12-12 0 8.001-12 18-12 36 0 19.881 16.119 36 36 36s36-16.119 36-36c0-32.001-24-44.001-24-60m10.2 64.281-3.399 12.6c-.858 3.135-3.681 5.4-7.032 5.4H30.483V55.08l23.04-21.279c2.523 1.272 4.221 3.84 4.221 6.807a7.6 7.6 0 0 1-1.278 4.221l.018-.027-6.801 10.281H63.18a7.28 7.28 0 0 1 7.011 9.252l.012-.051z"></path>
    </svg>
  ),
  table_games: (
    <svg fill="currentColor" viewBox="0 0 96 96" class="svg-icon ">
      {" "}
      <title></title>{" "}
      <path d="M60 0c-8.001 0-24 15.999-24 36 0 0-3.999-12-12-12 0 8.001-12 18-12 36 0 19.881 16.119 36 36 36s36-16.119 36-36c0-32.001-24-44.001-24-60m10.2 64.281-3.399 12.6c-.858 3.135-3.681 5.4-7.032 5.4H30.483V55.08l23.04-21.279c2.523 1.272 4.221 3.84 4.221 6.807a7.6 7.6 0 0 1-1.278 4.221l.018-.027-6.801 10.281H63.18a7.28 7.28 0 0 1 7.011 9.252l.012-.051z"></path>
    </svg>
  ),
  popular: (
    <svg fill="currentColor" viewBox="0 0 64 64" class="svg-icon ">
      {" "}
      <title></title>{" "}
      <path d="M7.363 42.39C8.362 29.61 22.09 17.1 25.288 12.415c2.778-4.206 1.719-9.203.83-11.4a.78.78 0 0 1 .893-1h-.004c13.889 2.918 14.589 13.48 14.169 18.206s.42 7.913 3.477 7.224S46.682 17 46.682 17s14.038 16.676 8.892 33.073c-2.587 8.574-9.032 12.19-14.448 13.89-.28.14-.56-.14-.56-.55.7-2.638 2.508-4.726 3.058-7.644 1.119-4.796-3.328-9.213-6.625-11.71-2.062-1.538-3.385-3.97-3.385-6.712q0-.191.008-.381v.018c0-.28-.42-.42-.55-.28a90 90 0 0 1-6.653 7.202l-.021.022c-5.136 5.696-7.784 12.09-3.198 19.175.14.28-.14.69-.41.56-11.4-3.067-16.117-11.69-15.427-21.273"></path>
    </svg>
  ),
  new: (
    <svg fill="currentColor" viewBox="0 0 64 64" class="svg-icon ">
      {" "}
      <title></title>{" "}
      <path d="M57.164 0a6.836 6.836 0 0 1 6.79 7.629l-.798 6.836-.011.133a28.9 28.9 0 0 1-8.266 17.086L44.188 42.367l.93 8.473L31.976 64 30.34 51.078c-8.374-3.028-14.1-8.943-17.438-17.437L0 32.023l13.16-13.14 8.473.93L32.316 9.12c4.491-4.477 10.446-7.494 17.22-8.277l6.8-.793q.408-.05.828-.05M8.637 41.125c2.4 6.9 7.869 12.368 14.937 14.82 0 0-4.697 8.467-20.676 5.649C.07 45.615 8.586 40.957 8.586 40.957zm35.64-30.187a7.995 7.995 0 0 0 0 15.988v.039a7.995 7.995 0 0 0 7.996-7.992v-.04a8 8 0 0 0-7.996-7.995"></path>
    </svg>
  ),
  crash_games: (
    <svg fill="currentColor" viewBox="0 0 64 64" class="svg-icon ">
      {" "}
      <title></title>{" "}
      <path d="M57.164 0a6.836 6.836 0 0 1 6.79 7.629l-.798 6.836-.011.133a28.9 28.9 0 0 1-8.266 17.086L44.188 42.367l.93 8.473L31.976 64 30.34 51.078c-8.374-3.028-14.1-8.943-17.438-17.437L0 32.023l13.16-13.14 8.473.93L32.316 9.12c4.491-4.477 10.446-7.494 17.22-8.277l6.8-.793q.408-.05.828-.05M8.637 41.125c2.4 6.9 7.869 12.368 14.937 14.82 0 0-4.697 8.467-20.676 5.649C.07 45.615 8.586 40.957 8.586 40.957zm35.64-30.187a7.995 7.995 0 0 0 0 15.988v.039a7.995 7.995 0 0 0 7.996-7.992v-.04a8 8 0 0 0-7.996-7.995"></path>
    </svg>
  ),
  other: (
    <svg fill="currentColor" viewBox="0 0 64 64" class="svg-icon ">
      {" "}
      <title></title>{" "}
      <path d="M57.164 0a6.836 6.836 0 0 1 6.79 7.629l-.798 6.836-.011.133a28.9 28.9 0 0 1-8.266 17.086L44.188 42.367l.93 8.473L31.976 64 30.34 51.078c-8.374-3.028-14.1-8.943-17.438-17.437L0 32.023l13.16-13.14 8.473.93L32.316 9.12c4.491-4.477 10.446-7.494 17.22-8.277l6.8-.793q.408-.05.828-.05M8.637 41.125c2.4 6.9 7.869 12.368 14.937 14.82 0 0-4.697 8.467-20.676 5.649C.07 45.615 8.586 40.957 8.586 40.957zm35.64-30.187a7.995 7.995 0 0 0 0 15.988v.039a7.995 7.995 0 0 0 7.996-7.992v-.04a8 8 0 0 0-7.996-7.995"></path>
    </svg>
  ),
  search_results: (
    <svg fill="currentColor" viewBox="0 0 64 64" class="svg-icon ">
      {" "}
      <title></title>{" "}
      <path d="M57.164 0a6.836 6.836 0 0 1 6.79 7.629l-.798 6.836-.011.133a28.9 28.9 0 0 1-8.266 17.086L44.188 42.367l.93 8.473L31.976 64 30.34 51.078c-8.374-3.028-14.1-8.943-17.438-17.437L0 32.023l13.16-13.14 8.473.93L32.316 9.12c4.491-4.477 10.446-7.494 17.22-8.277l6.8-.793q.408-.05.828-.05M8.637 41.125c2.4 6.9 7.869 12.368 14.937 14.82 0 0-4.697 8.467-20.676 5.649C.07 45.615 8.586 40.957 8.586 40.957zm35.64-30.187a7.995 7.995 0 0 0 0 15.988v.039a7.995 7.995 0 0 0 7.996-7.992v-.04a8 8 0 0 0-7.996-7.995"></path>
    </svg>
  ),
  "provably-fair": (
    <svg fill="currentColor" viewBox="0 0 64 64" class="svg-icon ">
      {" "}
      <title></title>{" "}
      <path d="M57.164 0a6.836 6.836 0 0 1 6.79 7.629l-.798 6.836-.011.133a28.9 28.9 0 0 1-8.266 17.086L44.188 42.367l.93 8.473L31.976 64 30.34 51.078c-8.374-3.028-14.1-8.943-17.438-17.437L0 32.023l13.16-13.14 8.473.93L32.316 9.12c4.491-4.477 10.446-7.494 17.22-8.277l6.8-.793q.408-.05.828-.05M8.637 41.125c2.4 6.9 7.869 12.368 14.937 14.82 0 0-4.697 8.467-20.676 5.649C.07 45.615 8.586 40.957 8.586 40.957zm35.64-30.187a7.995 7.995 0 0 0 0 15.988v.039a7.995 7.995 0 0 0 7.996-7.992v-.04a8 8 0 0 0-7.996-7.995"></path>
    </svg>
  ),
  skills: (
    <svg fill="currentColor" viewBox="0 0 64 64" class="svg-icon ">
      {" "}
      <title></title>{" "}
      <path d="M57.164 0a6.836 6.836 0 0 1 6.79 7.629l-.798 6.836-.011.133a28.9 28.9 0 0 1-8.266 17.086L44.188 42.367l.93 8.473L31.976 64 30.34 51.078c-8.374-3.028-14.1-8.943-17.438-17.437L0 32.023l13.16-13.14 8.473.93L32.316 9.12c4.491-4.477 10.446-7.494 17.22-8.277l6.8-.793q.408-.05.828-.05M8.637 41.125c2.4 6.9 7.869 12.368 14.937 14.82 0 0-4.697 8.467-20.676 5.649C.07 45.615 8.586 40.957 8.586 40.957zm35.64-30.187a7.995 7.995 0 0 0 0 15.988v.039a7.995 7.995 0 0 0 7.996-7.992v-.04a8 8 0 0 0-7.996-7.995"></path>
    </svg>
  ),
  crash: (
    <svg fill="currentColor" viewBox="0 0 64 64" class="svg-icon ">
      {" "}
      <title></title>{" "}
      <path d="M57.164 0a6.836 6.836 0 0 1 6.79 7.629l-.798 6.836-.011.133a28.9 28.9 0 0 1-8.266 17.086L44.188 42.367l.93 8.473L31.976 64 30.34 51.078c-8.374-3.028-14.1-8.943-17.438-17.437L0 32.023l13.16-13.14 8.473.93L32.316 9.12c4.491-4.477 10.446-7.494 17.22-8.277l6.8-.793q.408-.05.828-.05M8.637 41.125c2.4 6.9 7.869 12.368 14.937 14.82 0 0-4.697 8.467-20.676 5.649C.07 45.615 8.586 40.957 8.586 40.957zm35.64-30.187a7.995 7.995 0 0 0 0 15.988v.039a7.995 7.995 0 0 0 7.996-7.992v-.04a8 8 0 0 0-7.996-7.995"></path>
    </svg>
  ),
  original: (
    <svg fill="currentColor" viewBox="0 0 64 64" class="svg-icon ">
      {" "}
      <title></title>{" "}
      <path d="M57.164 0a6.836 6.836 0 0 1 6.79 7.629l-.798 6.836-.011.133a28.9 28.9 0 0 1-8.266 17.086L44.188 42.367l.93 8.473L31.976 64 30.34 51.078c-8.374-3.028-14.1-8.943-17.438-17.437L0 32.023l13.16-13.14 8.473.93L32.316 9.12c4.491-4.477 10.446-7.494 17.22-8.277l6.8-.793q.408-.05.828-.05M8.637 41.125c2.4 6.9 7.869 12.368 14.937 14.82 0 0-4.697 8.467-20.676 5.649C.07 45.615 8.586 40.957 8.586 40.957zm35.64-30.187a7.995 7.995 0 0 0 0 15.988v.039a7.995 7.995 0 0 0 7.996-7.992v-.04a8 8 0 0 0-7.996-7.995"></path>
    </svg>
  ),
  roulette: (
    <svg fill="currentColor" viewBox="0 0 64 64" class="svg-icon ">
      {" "}
      <title></title>{" "}
      <path d="M57.164 0a6.836 6.836 0 0 1 6.79 7.629l-.798 6.836-.011.133a28.9 28.9 0 0 1-8.266 17.086L44.188 42.367l.93 8.473L31.976 64 30.34 51.078c-8.374-3.028-14.1-8.943-17.438-17.437L0 32.023l13.16-13.14 8.473.93L32.316 9.12c4.491-4.477 10.446-7.494 17.22-8.277l6.8-.793q.408-.05.828-.05M8.637 41.125c2.4 6.9 7.869 12.368 14.937 14.82 0 0-4.697 8.467-20.676 5.649C.07 45.615 8.586 40.957 8.586 40.957zm35.64-30.187a7.995 7.995 0 0 0 0 15.988v.039a7.995 7.995 0 0 0 7.996-7.992v-.04a8 8 0 0 0-7.996-7.995"></path>
    </svg>
  ),
  baccarat: (
    <svg fill="currentColor" viewBox="0 0 64 64" class="svg-icon ">
      {" "}
      <title></title>{" "}
      <path d="M57.164 0a6.836 6.836 0 0 1 6.79 7.629l-.798 6.836-.011.133a28.9 28.9 0 0 1-8.266 17.086L44.188 42.367l.93 8.473L31.976 64 30.34 51.078c-8.374-3.028-14.1-8.943-17.438-17.437L0 32.023l13.16-13.14 8.473.93L32.316 9.12c4.491-4.477 10.446-7.494 17.22-8.277l6.8-.793q.408-.05.828-.05M8.637 41.125c2.4 6.9 7.869 12.368 14.937 14.82 0 0-4.697 8.467-20.676 5.649C.07 45.615 8.586 40.957 8.586 40.957zm35.64-30.187a7.995 7.995 0 0 0 0 15.988v.039a7.995 7.995 0 0 0 7.996-7.992v-.04a8 8 0 0 0-7.996-7.995"></path>
    </svg>
  ),
  poker: (
    <svg fill="currentColor" viewBox="0 0 64 64" class="svg-icon ">
      {" "}
      <title></title>{" "}
      <path d="M57.164 0a6.836 6.836 0 0 1 6.79 7.629l-.798 6.836-.011.133a28.9 28.9 0 0 1-8.266 17.086L44.188 42.367l.93 8.473L31.976 64 30.34 51.078c-8.374-3.028-14.1-8.943-17.438-17.437L0 32.023l13.16-13.14 8.473.93L32.316 9.12c4.491-4.477 10.446-7.494 17.22-8.277l6.8-.793q.408-.05.828-.05M8.637 41.125c2.4 6.9 7.869 12.368 14.937 14.82 0 0-4.697 8.467-20.676 5.649C.07 45.615 8.586 40.957 8.586 40.957zm35.64-30.187a7.995 7.995 0 0 0 0 15.988v.039a7.995 7.995 0 0 0 7.996-7.992v-.04a8 8 0 0 0-7.996-7.995"></path>
    </svg>
  ),
};

const gameTypeAPISlugsReverse = Object.fromEntries(
  Object.entries(gameTypeAPISlugs).map(([key, value]) => [value, key])
);

/** URL segment for `/games/:gameType` from API `game_types` slug or an existing route key. */
function getGamesPageCategoryPath(apiOrUrlCategory) {
  if (apiOrUrlCategory == null || apiOrUrlCategory === "") {
    return "all";
  }
  const s = String(apiOrUrlCategory);
  if (Object.prototype.hasOwnProperty.call(gameTypeAPISlugs, s)) {
    return s;
  }
  const fromReverse = gameTypeAPISlugsReverse[s];
  if (fromReverse != null) {
    return fromReverse;
  }
  return s.replace(/_/g, "-");
}

export {
  gameTypeAPISlugs,
  gameTitles,
  gameTypeAPISlugsReverse,
  gameTypeIcons,
  getGamesPageCategoryPath,
};
